import { Container, Box, IconButton, Link, styled, Typography } from '@mui/material'
import { QuestionAnswer as ChatIcon, WhatsApp as WhatsAppIcon } from '@mui/icons-material'
import { ByIntrasites } from '../../assets'
import { translate } from '../../utils/resources'
import DEFAULT from '../../config/default'

const isArgentina = DEFAULT.api.countryCode === 'AR'

const Footer = () => {
    return (
        <RootStyled>
            <Container>
                <MainStyled>
                    <PoweredByStyled>
                        <Link href="https://intrasites.com/?utm_source=nwt&utm_medium=footer&utm_campaign=arg" target="_blank" style={{ display: 'block' }}>
                            <img src={ByIntrasites} alt="step-0-status-0" style={{ width: 90, height: 11 }} />
                        </Link>
                    </PoweredByStyled>
                    { DEFAULT.project.chat && !isArgentina && (
                        <>
                            <Box sx={{ flexGrow: 1 }} />
                            <ChatActionStyled onClick={() => window.open(DEFAULT.project.chat)}>
                                <ChatActionButtonStyled>
                                    <ChatActionIconStyled />
                                </ChatActionButtonStyled>
                                <ChatActionDetailStyled>
                                    <Typography color="primary" variant="subtitle2" textTransform="uppercase" component="p">
                                        {translate('global.chat.title')}
                                    </Typography>
                                    <Typography variant="caption" component="p" lineHeight={1.2}>
                                        {translate('global.chat.subtitle')}
                                    </Typography>
                                </ChatActionDetailStyled>
                            </ChatActionStyled>
                        </>
                    )}
                </MainStyled>
            </Container>
            { DEFAULT.project.chat && isArgentina && (
                <WhatsAppActionStyled onClick={() => window.open(DEFAULT.project.chat)}>
                    <WhatsAppActionTextStyled>
                        <Typography variant="body2" component="p" fontWeight={500}>
                            {translate('global.chat.title')}
                        </Typography>
                    </WhatsAppActionTextStyled>
                    <WhatsAppActionButtonStyled>
                        <WhatsAppActionIconStyled />
                    </WhatsAppActionButtonStyled>
                </WhatsAppActionStyled>
            )}
        </RootStyled>
    )
}

const RootStyled = styled('footer')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    '@media all': {
        minHeight: 78
    }
}))

const MainStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center'
}))

const PoweredByStyled = styled(Box)(({ theme }) => ({
    
}))

const ChatActionStyled = styled(Box)(({ theme }) => ({
    position: 'relative',
    cursor: 'pointer'
}))

const ChatActionButtonStyled = styled(IconButton)(({ theme }) => ({
    background: theme.palette.primary.main,
    padding: theme.spacing(2),
    position: 'relative',
    zIndex: 1,
    '&:hover': {
        background: theme.palette.primary.dark
    }
}))

const ChatActionIconStyled = styled(ChatIcon)(({ theme }) => ({
    color: theme.palette.common.white,
    width: 32,
    height: 32,
}))

const ChatActionDetailStyled = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    height: 64,
    width: 430,
    padding: 8,
    paddingRight: 72,
    transform: 'translateX(-366px)',
    background: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    borderRadius: '4px 32px 32px 4px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
        width: 280,
        transform: 'translateX(-216px)',
    },
}))

const WhatsAppActionStyled = styled(Box)(({ theme }) => ({
    position: 'fixed',
    right: theme.spacing(3),
    bottom: theme.spacing(3),
    zIndex: theme.zIndex.speedDial,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
        right: theme.spacing(2),
        bottom: theme.spacing(2)
    }
}))

const WhatsAppActionTextStyled = styled(Box)(({ theme }) => ({
    background: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5, 2),
    marginRight: theme.spacing(1.5),
    maxWidth: 220,
    [theme.breakpoints.down('sm')]: {
        display: 'none'
    }
}))

const WhatsAppActionButtonStyled = styled(IconButton)(({ theme }) => ({
    background: '#25D366',
    padding: theme.spacing(2),
    boxShadow: theme.shadows[2],
    '&:hover': {
        background: '#20BD5B'
    }
}))

const WhatsAppActionIconStyled = styled(WhatsAppIcon)(({ theme }) => ({
    color: theme.palette.common.white,
    width: 32,
    height: 32,
}))

export default Footer
